import React from "react";
import HeroSlideshow from "./HeroSlideshow";

export const Header = () => {
  return (
    <header id="header">
      <HeroSlideshow />
    </header>
  );
};
